<template>

  <div class="modal-backdrop" v-if="show">
    <div class="modal">
        <multiselect
            v-model="locationProjet"
            label="text"
            track-by="value"
            placeholder="Localisation"
            select-label="✔"
            deselect-label="✘"
            :multiple="true"
            :options="LocationProjet"
            open-direction="bottom"
            :internal-search="false"
            :searchable="true"
            :show-no-results="false"
            :hide-selected="false"
            :close-on-select="true"
            :clear-on-select="true"
            @search-change="searchVille"
            @input="change"
            @remove="change2">
        </multiselect>
        <button type="button" class="btn" @click="change">Valider</button>
    </div>
  </div>
</template>
<script>
// import Input from "./Input";
import Multiselect from 'vue-multiselect'
import { mapActions, mapGetters, mapMutations } from "vuex";
import Store from '../../Store/Store'

export default {
  data() {
    return {
      locationProjet: null,
      LocationProjet: [],
      disableLocation: false,
      disableDepartment: false,
    };
  },
  props: {
    show : {
      type: Boolean,
    },
    location: {
      type: Object
    }
  },
  mounted() {
    
  },
  methods: {
    ...mapActions(["searchVilleByCP", "searchVilleByName","setProjectFilters"]),
    change() {
      // if(this.locationProjet != null) localStorage.setItem("locationProjet",JSON.stringify(this.locationProjet));
      
      this.$emit('selectedLocation', this.locationProjet)
    },
    change2() {
      // this.locationProjet = null
      this.$emit('unselectLocation', this.locationProjet)
      // if(this.locationProjet != null) localStorage.setItem("locationProjet",JSON.stringify(this.locationProjet));
    },
    isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    hasNumbers(t){
      var regex = /\d/g;
      return regex.test(t);
    },
    searchVille(query) {
        this.disableLocation = false;
        this.disableDepartment = true;
        if(this.isNumeric(query) || query == '2A' || query == '2B') {
            if(query.length >= 2) {
              this.searchVilleByCP({query: query}).then(res => {
                if(this.Location.length > 0){
                  this.LocationProjet = this.Location
                }
              })
            }
        }
        else {
            if(query.length > 2){
              this.searchVilleByName({query: query}).then(res => {
                if(this.Location.length > 0){
                  this.LocationProjet = this.Location
                }
              })
            }
        }
    },
  },
  computed: {
    ...mapGetters(["Location","locationProject","projectFilters"]),
   
  },
  components: { 
    Multiselect
  },
  watch: {
    show: {
      // the callback will be called immediately after the start of the observation
      immediate: true,
      handler: function(show) {
        if (show) {
          //desactive scroll in body
          //document.body.style.setProperty("overflow", "hidden");
        } else {
          document.body.style.removeProperty("overflow");
        }
      },
    },
    location(value) {
      this.locationProjet = value
    }
  },
};
</script>
<style scoped lang="scss">
.modal-backdrop {
  position: absolute;
  .modal {
    width: 165px;
    margin-top: 15px;
    background-color: #f2fdff;
    border-radius: 5px;
    padding: 15px;
     box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11);
    .btn {
      width: 100%;
      border-radius: 5px;
      border: none;
      color: white;
      background-color: #22abc5;
      padding: 12px;
      /* margin-left: 70%; */
      outline: 0;
      font-size: 15px;
      font-family: Metropolis;
      &:focus {
        border: none;
        background-color: #ff8c00;
      }
      &:hover {
        cursor: pointer;
      }
    }
  }
}
@media screen and (max-width: 375px) {
  .modal-backdrop {
  position: initial;
  .modal{
    width: 150px;
  }
  }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
